var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-component',{attrs:{"title":"Application On File"}}),_c('application-submit-recent-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }